export default function checkFasta(
  content,
  enqueueSnackbar,
  type = "Binding",
  annotation = false
) {
  let { valid: rightDefine, illegalString } = processFileCon(content, type);
  if (rightDefine) {
    enqueueSnackbar("Format check complete", { variant: "success" });
    return true;
  }

  if (illegalString) {
    enqueueSnackbar("There are illegal words. Check your format.", {
      variant: "error",
    });
    illegalString = false;
  } else {
    enqueueSnackbar("Please enter data in the same format as the sample.", {
      variant: "error",
    });
  }
  return false;
}

export function processFileCon(fileString, type = "Binding") {
  let enter_or_mix = fileString.search("\r\n");
  let arr_init = [];

  if (enter_or_mix !== -1) {
    arr_init = fileString.split("\r\n");
  } else {
    let enter_or_mix_n = fileString.search("\n");
    if (enter_or_mix_n !== -1) {
      arr_init = fileString.split("\n");
    } else {
      arr_init = fileString.split("\r");
    }
  }
  let arr = [];
  for (let index in arr_init) {
    if (arr_init[index] !== "") {
      arr.push(arr_init[index]);
    }
  }
  // if (arr.length % 2 === 1 && arr[arr.length - 1] === "") {
  //   arr.pop();
  // }

  var illegal_r = /[J]/i;

  for (let index in arr) {
    if (index == 0) {
      let just_r = arr[index].search("_");

      if (just_r === -1 && type !== "Detectability") {
        return { valid: false, illegalString: false };
      } else {
        if (type !== "Detectability") {
          let just_current = arr[index].split("_");
          console.log(just_current, just_current.length);
          if (just_current.length < 2) {
            return { valid: false, illegalString: false };
          } else {
            let just_r_space = arr[index].search(" ");
            if (
              just_current[1].length > 5 ||
              just_r_space !== -1 ||
              just_current[1] === ""
            ) {
              return { valid: false, illegalString: false };
            }
          }
        }
      }
    }
  }

  return { valid: true, illegalString: false };
}
